import { phraseAnimationPlan, prefersReducedMotion } from './phraseAnimationPlan';

export const mountPhraseAnimation = (phraseName, text, setPhrase, animationStyle = "linear") => {
  const plan = phraseAnimationPlan(text, {
    reduced: prefersReducedMotion(),
    preset: animationStyle,
  });

  if (plan.mode === 'instant') {
    setPhrase(<span key={`letters-${phraseName}-instant`}>{text}</span>);
    return;
  }

  const result = [];
  let line = -1;
  plan.letters.forEach((letter, idCount) => {
    if (letter.lineIndex !== line) {
      if (line !== -1) result.push(<br key={`br-${phraseName}-${letter.lineIndex}`} />);
      line = letter.lineIndex;
    }
    result.push(
      <span
        key={`letters-${phraseName}-${idCount}`}
        style={{
          animationName: letter.preset,
          animationDuration: `${letter.duration}s`,
          animationDelay: `${letter.delay}s`,
          animationFillMode: 'forwards',
        }}
        className="letter"
      >
        {letter.ch}
      </span>
    );
  });
  setPhrase(result);
}

export const unMountPhraseAnimation = async (phraseName, phrase, setPhrase, animationStyle = "linear") => {
  const result = [];
  let idCount = 0;
  let animationDelaySeconds = 0;

  for (const letter of phrase) {
    result.push(
      <span
        key={`letters-${phraseName}-${idCount}`}
        style={{
          animationName: `un${animationStyle}`,
          animationDuration: '2s',
          animationDelay: `${animationDelaySeconds}s`,
          animationFillMode: 'forwards',
        }}
      >
        {letter}
      </span>
    )
    idCount++;
    animationDelaySeconds += .01;
  }
  setPhrase(result)
}
